$(document).on("click",".variant-option__button-label",function() {
//   var value = $(this).parents('.swatch-element').find('input').val()
//   $(this).parents('.swatch').find('.option_title span').text(value);

  setTimeout(function() {
    fetch(`${window.location.href}`).then((response) => {
      return response.text();
    })
    .then((responseText) => {
      const html = new DOMParser().parseFromString(responseText, 'text/html').querySelector('#line-shipping-info');
      document.querySelector('#line-shipping-info').innerHTML = html.innerHTML;
    })
    .catch(e => {
      console.error(e);
    })
    .finally(() => {
    });
  }, 50);
});